export const auth0Config = {
  domain: "dev-8ugzhhp2v2jdsph3.us.auth0.com",
  clientId: "cWKDIXyXt0MaYUTXJRfh3XKcmSbp8zN7",
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: "https://elaquelarre-api",
    scope: "openid profile email read:roles",
  },
  cacheLocation: "localstorage",
  useRefreshTokens: true,
  advancedOptions: {
    defaultScope: "openid profile email read:roles"
  }
};
